import script from "./AppMain.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=ts"

import "./AppMain.vue?vue&type=style&index=0&id=5a9386f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a9386f2"]])

export default __exports__